import { useMemo } from "react";
import { LatLngLiteral } from "leaflet";

import { useIndicator } from "hooks/indicatorHooks";

import { IndicatorSelection, LayerProperties } from "../../types";

import { SelectedLayerGeometry } from "./SelectedLayerGeometry";

interface Props {
  config: string;
  selection: IndicatorSelection;
  point: LatLngLiteral;
  layerProperties: LayerProperties[];
}

export function SelectedLayerGeometryLoad(props: Props) {
  const { config, selection, point, layerProperties } = props;

  const { data: indicator } = useIndicator(
    config,
    selection.indicatorId,
    layerProperties
  );
  const layer = useMemo(
    () =>
      (indicator?.layers || []).find((layer) => layer.id === selection.layerId),
    [selection, indicator]
  );
  if (layer) return <SelectedLayerGeometry point={point} layer={layer} />;
  return null;
}
